import * as PIXI from "pixi.js";
import starPng from "../../lib/assets/icons/star.png";
import * as TWEEN from "@tweenjs/tween.js";

import { isMobile } from "react-device-detect";

let starAmount = 500;
let cameraZ = 0;
const fov = 20;
const baseSpeed = 0.025;
let speed = 0;
let starStretch = 2;
const starBaseSize = 0.5;
let coefVal = 0;
let errorPage = false;

// Create the stars
const stars: any = [];
const starContainer = new PIXI.Sprite();

const mapValue = (x: any) => {
  // const x0 = 1;
  // const x1 = 8;
  // const y0 = 1.5;
  // const y1 = 6.5;
  // const y = y0 + ((y1 - y0) * (x - x0)) / (x1 - x0);
  let y = 0.5;
  switch (true) {
    case x > 1 && x < 1.5:
      y = 2;
      break;
    case x >= 1.5 && x < 2:
      y = 2.5;
      break;
    case x >= 2 && x < 3:
      y = 3.5;
      break;
    case x >= 3 && x < 4:
      y = 4.5;
      break;
    case x >= 4:
      y = 6.5;
      break;
    default:
      break;
  }
  return y;
};

if (isMobile) {
  starAmount = 200;
  starStretch = 1;
} else {
  starAmount = 600;
  starStretch = 3;
}
const randomizeStar = (star: any, initial: any) => {
  star.z = initial
    ? Math.random() * 2000
    : cameraZ + Math.random() * 1000 + 2000;
  // Calculate star positions with radial random coordinate so no star hits the camera.
  const deg = Math.random() * Math.PI * 2;
  const distance = Math.random() * 40 + 1;
  star.x = Math.cos(deg) * distance;
  star.y = Math.sin(deg) * distance;
};
let timeout: any;
let interval: any;

export const valueUpdate = (
  value: any,
  state: any,
  isError: any,
  jackpotState: any,
) => {
  // isError
  //   ? (coefVal = 0)
  //   : state === 2 && value > 1.05
  //   ? (coefVal = 0.8)
  //   : (coefVal = 0.2);
  const limit = document.body.clientWidth >= 1024 ? 15 : 10;
  if (jackpotState !== "initJackpot" && jackpotState !== "finished") {
    coefVal = mapValue(Number(value));
  }
  if (state === 3) {
    coefVal = 0.5;
  }
  if (isError) {
    coefVal = 0;
  }

  if (jackpotState === "finished") {
    new TWEEN.Tween(starContainer)
      .to({ alpha: 1 }, 300)
      .easing(TWEEN.Easing.Linear.None)
      .start();
    starContainer.scale.set(1, 1);
  }
  if (jackpotState === "initJackpot") {
    timeout = setTimeout(() => {
      const tmpObj = {
        coefVal: coefVal,
      };
      new TWEEN.Tween(tmpObj)
        .to({ coefVal: limit }, 4000)
        .easing(TWEEN.Easing.Linear.None)
        .onUpdate(() => {
          coefVal = tmpObj.coefVal;
        })
        .start();
    }, 2000);
  }

  if (jackpotState === "initBlackHole") {
    coefVal = limit;
    const tmpObj = {
      coefVal: limit,
    };
    new TWEEN.Tween(tmpObj)
      .to({ coefVal: 1.5 }, 1000)
      .easing(TWEEN.Easing.Linear.None)
      .onUpdate(() => {
        coefVal = tmpObj.coefVal;
      })
      .start();
    clearTimeout(timeout);
    clearInterval(interval);
  }
  errorPage = isError;
};

export const createStars = (stage: any, ticker: any, app: any) => {
  // Get the texture for rope.
  const starTexture = PIXI.Texture.from(starPng);

  for (let i = 0; i < starAmount; i++) {

    const star = {
      sprite: new PIXI.Sprite(starTexture),
      z: 0,
      x: 0,
      y: 0,
    };
    star.sprite.alpha = 0.7;
    star.sprite.anchor.x = 0.5;
    star.sprite.anchor.y = 0.7;
    randomizeStar(star, true);
    starContainer.addChild(star.sprite);

    stars.push(star);
  }
  starContainer.name = "starContainer";
  stage.addChild(starContainer);
  ticker.add((delta: any) => {
    // Change speed depend on coeficient

    speed = coefVal;
    cameraZ += delta * 10 * (speed + baseSpeed);
    for (let i = 0; i < starAmount; i++) {
      const star = stars[i];
      if (star.z < cameraZ) randomizeStar(star, false);

      const z = star.z - cameraZ;

      star.sprite.x = star.x * (fov / z) * app.renderer.screen.width;
      star.sprite.y = star.y * (fov / z) * app.renderer.screen.width;

      const dxCenter = star.sprite.x;
      const dyCenter = star.sprite.y;

      const distanceCenter = Math.sqrt(
        dxCenter * dxCenter + dyCenter * dyCenter
      );
      const distanceScale = Math.max(0, (2000 - z) / 2000);
      star.sprite.scale.x = distanceScale * starBaseSize;
      // Star is looking towards center so that y axis is towards center.
      // Scale the star depending on how fast we are moving, what the stretchfactor is and depending on how far away it is from the center.
      star.sprite.scale.y =
        distanceScale * starBaseSize +
        (distanceScale * speed * starStretch * distanceCenter) /
          app.renderer.screen.width;
      star.sprite.rotation = Math.atan2(dyCenter, dxCenter) + Math.PI / 2;
    }
  });
};
